var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _c("div", { staticClass: "col-5" }, [
        _c("h5", [_vm._v(_vm._s(_vm.pageTitle))]),
      ]),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("キャンセルする")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.register.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.role.roleName,
                        expression: "role.roleName",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "40",
                      autocomplete: "off",
                      placeholder: [[_vm.roleDisplayHolder]],
                      required: "",
                    },
                    domProps: { value: _vm.role.roleName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.role, "roleName", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "ul",
                _vm._l(this.functions, function (func) {
                  return _c("li", { key: func.functionCode }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-4" }, [
                        _c("label", [_vm._v(_vm._s(func.functionCode))]),
                      ]),
                      _c("div", { staticClass: "col-4" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.functionIdList,
                              expression: "functionIdList",
                            },
                          ],
                          attrs: {
                            name: func.functionCode,
                            id: func.functionCode + "True",
                            type: "checkbox",
                          },
                          domProps: {
                            value: func.id,
                            checked: Array.isArray(_vm.functionIdList)
                              ? _vm._i(_vm.functionIdList, func.id) > -1
                              : _vm.functionIdList,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.functionIdList,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = func.id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.functionIdList = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.functionIdList = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.functionIdList = $$c
                              }
                            },
                          },
                        }),
                        _c(
                          "label",
                          {
                            staticClass: "radio-label",
                            attrs: { for: func.functionCode + "True" },
                          },
                          [_vm._v("利用する")]
                        ),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
            ]),
            _c(
              "button",
              {
                staticClass: "btn btn-info btn btn-block",
                attrs: { id: "register_button", type: "submit" },
              },
              [_vm._v("登録する")]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [_c("label", [_vm._v("名称")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }